import CardBasic from 'components/Cards/Card.basic'
import React, { useEffect, useState } from 'react'
import { Badge, Button, Form, Modal, Table } from 'react-bootstrap'
import { useParams } from 'react-router-dom';
import { CenterAdminService } from 'Services/CenterAdmin.service';
import { ExamServices } from 'Services/examServices';
import Select from 'react-select';
import { toast } from 'react-toastify';
import PromptModal from 'components/Modals/Prompt.modal';
import moment from 'moment';
import DCMDropdown from 'components/DropDown/DropDown.index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faEdit, faEllipsisVertical, faRefresh, faToggleOff } from '@fortawesome/free-solid-svg-icons';

export default function CenterAdmin() {
    const [show, setShow] = useState<boolean>(false);
    const [clientData, setClientData] = useState<any>({});
    const [selectedCenters, setSelectedCenters] = useState<any>([]);
    const [cities, setCities] = useState<any>([]);
    const [newClient, setNewClient] = useState<any>(null);
    const [centerAdmins, setCenterAdmins] = useState<any>([]);
    const [isUpdate, setIsUpdate] = useState<string>("");


    let { examId } = useParams();

    function handleModalClose() {
        setShow(false);
        setIsUpdate("");
        setClientData({});
        setSelectedCenters([]);
    }

    const getAllExamCities = async () => {
        await ExamServices.getAllExamCities(examId).then((res) => {
            if (res.status === 200) {
                setCities(res.data?.uniqueCitites?.map((data: any) => {
                    return {
                        label: data,
                        value: data
                    }
                }))
            }
        })
    }

    async function createCenterAdmin() {
        if (!clientData.name || !clientData.email) {
            toast.error("Please enter username and email")
            return;
        }
        if (!selectedCenters.length) {
            toast.error("Please select centers")
            return;
        }

        let payload = {
            ...clientData,
            allotedCenters: selectedCenters?.map((data: any) => data.value),
            examId: examId
        }

        if (!isUpdate || isUpdate === "") {
            await CenterAdminService.createCenterAdmin(payload)
                .then((res) => {
                    if (res.status === 200) {
                        setNewClient(res.data?.admin);
                        handleModalClose();
                        toast.success("Center Admin Created Successfully");
                    }
                }).catch(err => {
                    toast.error(err.response?.data?.message || err.response?.data || "Something went wrong");
                })
        } else {
            await CenterAdminService.updateCenterAdmin(isUpdate, payload)
                .then((res) => {
                    if (res.status === 200) {
                        handleModalClose();
                        toast.success("Center Admin Updated Successfully");
                        getAllCenterAdmin();
                    }
                }).catch(err => {
                    toast.error(err.response?.data?.message || err.response?.data || "Something went wrong");
                })
        }
    }

    async function handleResetPassword(id: string) {
        await CenterAdminService.resetPassword(id)
            .then((res) => {
                if (res.status === 200) {
                    toast.success(res.data?.message || "Password Reset Successfully");
                    getAllCenterAdmin();
                    setNewClient(res.data?.admin);
                }
            })
            .catch(err => {
                toast.error(err.response?.data?.message || err.response?.data || "Something went wrong");
            })
    }

    async function getAllCenterAdmin() {
        await CenterAdminService.getAllCenterAdmin(examId)
            .then((res) => {
                if (res.status === 200) {
                    setCenterAdmins(res.data || []);
                }
            })
            .catch(err => {
                toast.error(err.response?.data?.message || err.response?.data || "Something went wrong");
            })
    }

    async function handelToggleSuspend(id: string) {
        await CenterAdminService.toggleSuspend(id)
            .then((res) => {
                if (res.status === 200) {
                    getAllCenterAdmin();
                    toast.success(res.data?.message || "Successfully updated");
                }
            })
            .catch(err => {
                toast.error(err.response?.data?.message || err.response?.data || "Something went wrong");
            })
    }

    function handleChange(e: any) {
        setClientData({ ...clientData, [e.target.name]: e.target.value });
    }

    useEffect(() => {
        getAllExamCities();
        getAllCenterAdmin();
    }, [])


    return (
        <>
            <CardBasic
                cardClass="mt-3"
                title={
                    <div className="d-flex justify-content-between">
                        <h5>Center Admin</h5>
                        <div className="d-flex align-items-center gap-3 ">
                            <Button variant='secondary' onClick={() => setShow(true)}>Create Center Admin</Button>
                        </div>

                    </div>
                }
                body={
                    <>
                        <Table striped borderless hover className="xrg-table" size="sm" responsive="md">
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Username</th>
                                    <th>Email</th>
                                    <th>Suspended</th>
                                    <th>Alloted Centers</th>
                                    <th>Created At</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    centerAdmins?.length >= 0 ?
                                        centerAdmins?.map((data: any, index: number) => {
                                            return (
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td>{data?.name}</td>
                                                    <td>{data?.email}</td>
                                                    <td>{data?.isSuspended ? <Badge bg='danger'>Suspended</Badge> : <Badge bg='success'>Active</Badge>}</td>
                                                    <td>{data?.allotedCenters?.map((data: any) => <Badge className="ms-2" key={data} bg='primary'>{data}</Badge>)}</td>
                                                    <td>{moment(data?.createdAt).format("DD-MM-YYYY")}</td>
                                                    <td>
                                                        <DCMDropdown
                                                            menuLabel={<FontAwesomeIcon icon={faEllipsisVertical} />}
                                                            menuItems={[
                                                                {
                                                                    label: (
                                                                        <div className="text-secondary">
                                                                            <FontAwesomeIcon icon={faToggleOff} className="me-2" />
                                                                            {
                                                                                data?.isSuspended ? "Unsuspend" : "Suspend"
                                                                            }
                                                                        </div>
                                                                    ),
                                                                    onClick: () => handelToggleSuspend(data?._id),
                                                                },
                                                                {
                                                                    label: (
                                                                        <div className="text-secondary">
                                                                            <FontAwesomeIcon icon={faEdit} className="me-2" />
                                                                            Update
                                                                        </div>
                                                                    ),
                                                                    onClick: () => {
                                                                        setIsUpdate(data?._id);
                                                                        setClientData({ name: data?.name, email: data?.email });
                                                                        setSelectedCenters(
                                                                            cities?.filter((city: any) => data?.allotedCenters?.includes(city.value))
                                                                        );
                                                                        setShow(true);
                                                                    },
                                                                },
                                                                {
                                                                    label: (
                                                                        <div className="text-secondary">
                                                                            <FontAwesomeIcon icon={faRefresh} className="me-2" />
                                                                            Reset Password
                                                                        </div>
                                                                    ),
                                                                    onClick: () => handleResetPassword(data?._id),
                                                                },
                                                            ]}
                                                        />
                                                    </td>
                                                </tr>
                                            )
                                        }) : <tr><td colSpan={8} className='text-center'>No Data Found</td></tr>
                                }
                            </tbody>
                        </Table>
                    </>
                }
            />

            <Modal
                show={show}
                onHide={handleModalClose}
                animation={true}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{
                        isUpdate ? "Update Center Admin" : "Create Center Admin"
                    }</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Username</Form.Label>
                        <Form.Control name='name' onChange={(e: any) => handleChange(e)} value={clientData?.name} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Email</Form.Label>
                        <Form.Control name='email' onChange={(e: any) => handleChange(e)} value={clientData?.email} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Allowed Cities</Form.Label>
                        <Select
                            options={cities}
                            className="w-100"
                            placeholder="Filter.."
                            value={selectedCenters}
                            onChange={(e: any) => setSelectedCenters(e)}
                            isClearable
                            isMulti
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={createCenterAdmin}>
                        {
                            isUpdate ? "Update" : "Create"
                        }
                    </Button>
                </Modal.Footer>
            </Modal>

            <PromptModal
                show={newClient && newClient?.password}
                setShow={() => setNewClient(null)}
                body={
                    <>
                        <div>
                            <p>
                                Client Details.
                            </p>
                            <p>Email: <b>{newClient?.email}</b></p>
                            <p>Name: <b>{newClient?.name}</b></p>
                            <p>Password: <b>{newClient?.password}</b></p>
                            <p>Alloted Centers:
                                {
                                    newClient?.allotedCenters?.map((data: any) => <Badge className="ms-2" key={data} bg='primary'>{data}</Badge>)
                                }
                            </p>
                        </div>
                    </>
                }
            />
        </>
    )
}